<template>
  <LightBox>
    <FormHeading :h="4">{{ $tt('accompanying_children.label') }}</FormHeading>
    <AppBtn @click="add">
      <AppIcon icon="mdi:plus" start />
      {{ $tt('accompanying_children.add') }}
    </AppBtn>
    <div v-for="(child, i) in children">
      <v-divider />
      <div class="flex items-center mb-4 gap-2">
        <FormHeading :h="5" class="mb-0">
          {{ $tt('accompanying_children.index', { n: i + 1 }) }}
        </FormHeading>
        <CloseBtn size="small" @click="remove(i)" />
      </div>
      <AppRow :split="[3, 5, 4]">
        <TextField v-model="child.name" :label="$tt('accompanying_children.name')" :rules="[required]" />
        <DatePicker v-model="child.dateOfBirth" :label="$tt('accompanying_children.dob')" past />
        <CountrySelect v-model="child.countryOfBirth" :label="$tt('accompanying_children.country_of_birth')" :rules="[required]" />
      </AppRow>
    </div>
  </LightBox>
</template>

<script setup lang="ts">
import type { AccompanyingChild } from '~/types';

const children = defineModel<AccompanyingChild[]>({ required: true });

const { required } = useValidation();
const { baseCountry } = useBranch();

function add() {
  children.value.push({
    name: '',
    dateOfBirth: '',
    countryOfBirth: baseCountry
  });
}
function remove(i: number) {
  children.value.splice(i, 1);
}
</script>